import React from 'react';
import cn from 'classnames';

import './styles.css';

const ArrowButton = (props) => {
    const { onClick, customClass } = props;

    return (
        <button className={cn('arrow-button', customClass)} onClick={onClick} />
    );
};

export default ArrowButton;
